import styled from "styled-components";

interface ContainerProps {
  $isPhone: boolean;
}

interface TextProps {
  $isPhone: boolean;
}

export const BookingInformationFormWrapper = styled.div`
  .containerItem {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .containerSVG {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      svg {
        font-size: 20px;
        color: #5b3fff;
      }
    }
    > p {
      margin: 0;
      padding: 0;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #130080;
      margin-bottom: 16px;
    }
    label {
      p {
        font-weight: 400;
        font-size: 14px;
      }
    }
    &:nth-child(odd) {
      border-bottom: 1px solid #e3e8ef;
      margin-bottom: 14px;
    }
  }
`;

export const PaymentInfoContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  border-radius: ${({ $isPhone }) => ($isPhone ? "12px" : "16px")};
  background: #f8f8f8;
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "130px")};
  min-height: ${({ $isPhone }) => ($isPhone ? "100px" : "126px")};
  padding: ${({ $isPhone }) => ($isPhone ? "12px" : "16px")};
  justify-content: space-between;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "0")};
`;

export const PaymentHeader = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "10px")};

  svg {
    width: ${({ $isPhone }) => ($isPhone ? "18px" : "20px")};
    height: ${({ $isPhone }) => ($isPhone ? "18px" : "20px")};
  }
`;

export const PaymentTitle = styled.span<TextProps>`
  text-align: center;
  translate: 0 2px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  font-style: normal;
  font-weight: 500;
  color: #130080;
`;

export const PaymentRow = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "0")};
`;

export const PaymentLabel = styled.span<TextProps>`
  color: #8e98a1;
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "12px" : "14px")};
`;

export const PaymentValue = styled.span<TextProps>`
  color: #8e98a1;
  font-weight: 500;
  font-size: ${({ $isPhone }) => ($isPhone ? "12px" : "14px")};
`;

export const TotalPriceLabel = styled.span<TextProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  font-style: normal;
  font-weight: 500;
  color: #130080;
`;

export const TotalPriceValue = styled.span<TextProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "12px" : "14px")};
  font-style: normal;
  font-weight: 500;
  color: #130080;
  border-radius: 8px;
  border: 1px solid #d9d9e9;
  padding: ${({ $isPhone }) => ($isPhone ? "3px 8px" : "4px 12px")};
  display: inline-block;
  white-space: nowrap;
`;

export const DirectPaymentContainer = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ $isPhone }) => ($isPhone ? "24px" : "40px")};
  gap: ${({ $isPhone }) => ($isPhone ? "12px" : "0")};

  ${({ $isPhone }) =>
    $isPhone &&
    `
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const DirectPaymentTextContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "16px")};
`;

export const DirectPaymentTitle = styled.span<TextProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: #000000;
  font-weight: 500;
`;

export const DirectPaymentSubtitle = styled.span<TextProps>`
  font-size: ${({ $isPhone }) => ($isPhone ? "9px" : "10px")};
  color: #000000b2;
  font-weight: 400;
  line-height: 1.2;
`;

export const SaveButton = styled.button<ContainerProps>`
  width: 100%;
  height: ${({ $isPhone }) => ($isPhone ? "36px" : "40px")};
  background-color: #5b3fff;
  color: #fff;
  margin-top: ${({ $isPhone }) => ($isPhone ? "32px" : "49px")};
  border: none;
  border-radius: 12px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4a2fd8;
  }

  &:active {
    background-color: #3f28b8;
  }
`;
